module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chap_section"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("TIMELINE")])]), _vm._v(" "), _c('p', {
    staticClass: "numhanga"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("C7th")])]), _vm._v(" Use of ‘Greek Fire’ by the Byzantine navy.")]), _vm._v(" "), _c('p', {
    staticClass: "numhang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("C10th")])]), _vm._v(" First recorded use of gunpowder weapons by the Chinese.")]), _vm._v(" "), _c('p', {
    staticClass: "numhang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1241")])]), _vm._v(" Mongols may have used gunpowder weapons at the battle of Mohi, the first use of this technology in Europe.")]), _vm._v(" "), _c('p', {
    staticClass: "numhang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1326")])]), _vm._v(" First written evidence of the use of artillery in Europe.")]), _vm._v(" "), _c('p', {
    staticClass: "numhang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "num1"
  }, [_vm._v("c.1380")])]), _vm._v(" Venetians use cast-iron balls, and mounting bombards in their galleys.")]), _vm._v(" "), _c('p', {
    staticClass: "numhang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "num1"
  }, [_vm._v("c.1509")])]), _vm._v(" First gunports on warships.")]), _vm._v(" "), _c('p', {
    staticClass: "numhang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1515")])]), _vm._v(" Battle of Marignano – history’s full-scale artillery bombardment on a battlefield.")]), _vm._v(" "), _c('p', {
    staticClass: "numhang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1537")])]), _vm._v(" First Western artillery treatise, Nicolo Tartaglia’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("La Nova Sciento Invento")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "numhang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("C16th")])]), _vm._v(" First development of indirect fire mortars and howitzers.")]), _vm._v(" "), _c('p', {
    staticClass: "numhang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("C16th/17th")])]), _vm._v(" Fortifications redesigned to resist artillery, culminating in the designs of Vauban.")]), _vm._v(" "), _c('p', {
    staticClass: "numhang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1618–48")])]), _vm._v(" Thirty Years War. Gustavus II Adolphus divides his artillery train into field guns and siege guns.")]), _vm._v(" "), _c('p', {
    staticClass: "numhang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("Late C17th")])]), _vm._v(" Cartridges begin to be used rather than loose powder, speeding up loading.")]), _vm._v(" "), _c('p', {
    staticClass: "numhang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1693")])]), _vm._v(" French army establish a permanent regiment of artillery.")]), _vm._v(" "), _c('p', {
    staticClass: "numhang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "num1"
  }, [_vm._v("c.1700")])]), _vm._v(" Invention of grenade throwers and more effective howitzers.")]), _vm._v(" "), _c('p', {
    staticClass: "numhang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1756–63")])]), _vm._v(" Seven Years War. Frederick the Great forms batteries of horse artillery.")]), _vm._v(" "), _c('p', {
    staticClass: "numhang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1765")])]), _vm._v(" Gribeauval artillery system approved by Louis XVI of France.")]), _vm._v(" "), _c('p', {
    staticClass: "numhang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1803")])]), _vm._v(" Shrapnel shells adopted by the British army.")]), _vm._v(" "), _c('p', {
    staticClass: "numhang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1837")])]), _vm._v(" Paixhans guns firing explosive shells enter service in France.")]), _vm._v(" "), _c('p', {
    staticClass: "numhang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1840s")])]), _vm._v(" Royal Navy starts to use 68-pounder smoothbore shell guns. Percussion system of ignition adopted for artillery use, later replaced by friction primer system.")]), _vm._v(" "), _c('p', {
    staticClass: "numhang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1850s/60s")])]), _vm._v(" Adoption of Beaulieu rifled muzzle- loading guns by the French; Armstrong rifled breech-loading guns (RBLs) by the British; and Krupp rifled breech-loading guns by the Prussians.")]), _vm._v(" "), _c('p', {
    staticClass: "numhang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1865")])]), _vm._v(" Development of first type of smokeless gunpowder.")]), _vm._v(" "), _c('p', {
    staticClass: "numhang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1877")])]), _vm._v(" French produce the De Bange 90-mm, the first modern breech-loading gun.")]), _vm._v(" "), _c('p', {
    staticClass: "numhang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1880s")])]), _vm._v(" Development of time fuses for shells; armour-piercing rounds; and Quick Firing guns.")]), _vm._v(" "), _c('p', {
    staticClass: "numhang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1897")])]), _vm._v(" The 75-mm Quick Firing Gun enters service with the French Army. Development of accurate sighting devices improve accuracy.")]), _vm._v(" "), _c('p', {
    staticClass: "numhang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1905")])]), _vm._v(" The launch of HMS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dreadnought")]), _vm._v(" transformed naval warfare, ushering in the ‘Dreadnought Era’.")]), _vm._v(" "), _c('p', {
    staticClass: "numhang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1914–18")])]), _vm._v(" World War I. Development of rolling barrage, box barrage. Development of the first tracked artillery transports, and anti-aircraft guns.")]), _vm._v(" "), _c('p', {
    staticClass: "numhang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1916")])]), _vm._v(" British and German navies clash at Jutland, the only full-scale naval battle of the war.")]), _vm._v(" "), _c('p', {
    staticClass: "numhang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1939–45")])]), _vm._v(" World War II. Development of armour-piercing discarding sabot (APDS) rounds, and high explosive anti-tank (HEAT) rounds. Invention of radar enables sophisticated fire control systems.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c31a15e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Timeline.vue
// module id = 75
// module chunks = 0